var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedPassionFruit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M726.534827 56.661333l33.788586 23.15264-161.928533 236.291414-33.792-23.156054z",
    fill: "#D6BB38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M535.906987 255.634773c17.199787-18.991787 45.779627-29.36832 65.580373-18.37056l32.750933 20.165974c19.79392 10.994347 27.794773 39.161173 17.083734 69.147306-13.626027 23.95136-19.203413 44.38016-61.3376 21.183147l-32.873814-19.97824c-49.33632-27.938133-37.9392-52.80768-21.203626-72.147627z",
    fill: "#D6BB38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M420.05504 559.104m-324.51584 0a324.51584 324.51584 0 1 0 649.03168 0 324.51584 324.51584 0 1 0-649.03168 0Z",
    fill: "#CE1B60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M420.05504 904.09984c-190.231893 0-344.99584-154.763947-344.99584-344.992427 0-190.231893 154.763947-344.99584 344.99584-344.99584s344.99584 154.763947 344.99584 344.99584c0 190.22848-154.763947 344.992427-344.99584 344.992427z m0-649.028267c-167.645867 0-304.03584 136.389973-304.03584 304.03584 0 167.642453 136.389973 304.032427 304.03584 304.032427s304.03584-136.389973 304.03584-304.032427c0-167.645867-136.389973-304.03584-304.03584-304.03584z",
    fill: "#B20055"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.896853 672.641707a20.452693 20.452693 0 0 1-19.268266-13.585067c-2.290347-6.423893-54.729387-158.849707 63.218346-290.06848a20.48 20.48 0 1 1 30.464 27.385173c-101.2736 112.667307-57.01632 243.469653-55.08096 248.982187a20.50048 20.50048 0 0 1-19.33312 27.286187z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M293.19168 335.274667m-23.538347 0a23.538347 23.538347 0 1 0 47.076694 0 23.538347 23.538347 0 1 0-47.076694 0Z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M640.003413 667.275947m-288.457386 0a288.457387 288.457387 0 1 0 576.914773 0 288.457387 288.457387 0 1 0-576.914773 0Z",
    fill: "#FFFFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M640.003413 976.213333c-170.349227 0-308.937387-138.591573-308.937386-308.937386 0-170.349227 138.58816-308.937387 308.937386-308.937387 170.345813 0 308.937387 138.58816 308.937387 308.937387 0 170.345813-138.591573 308.937387-308.937387 308.937386z m0-576.914773c-147.7632 0-267.977387 120.214187-267.977386 267.977387S492.240213 935.253333 640.003413 935.253333s267.977387-120.214187 267.977387-267.977386-120.214187-267.977387-267.977387-267.977387z",
    fill: "#B20055"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M640.003413 667.27936m-234.37312 0a234.37312 234.37312 0 1 0 468.74624 0 234.37312 234.37312 0 1 0-468.74624 0Z",
    fill: "#FFE600"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M624.289257 646.140227a19.83488 28.84608 58.937 1 0 49.419131-29.768017 19.83488 28.84608 58.937 1 0-49.419131 29.768017Z",
    fill: "#D3A218"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M782.961137 739.816559a19.828053 28.84608 58.937 1 0 49.419132-29.768016 19.828053 28.84608 58.937 1 0-49.419132 29.768016Z",
    fill: "#D3A218"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M675.75896 839.078492a28.84608 19.83488 72.476 1 0-17.371413-55.01472 28.84608 19.83488 72.476 1 0 17.371413 55.01472Z",
    fill: "#D3A218"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M618.022547 720.05817a28.84608 19.831467 72.476 1 0-17.371413-55.014719 28.84608 19.831467 72.476 1 0 17.371413 55.014719Z",
    fill: "#D3A218"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M577.438306 801.118102a19.831467 28.84608 58.937 1 0 49.419131-29.768016 19.831467 28.84608 58.937 1 0-49.419131 29.768016Z",
    fill: "#D3A218"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M647.54202 722.011713a28.84608 19.83488 37.112 1 0 46.00705 34.810008 28.84608 19.83488 37.112 1 0-46.00705-34.810008Z",
    fill: "#D3A218"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M686.250581 698.080153a19.828053 28.842667 19.56 1 0 19.312692-54.356394 19.828053 28.842667 19.56 1 0-19.312692 54.356394Z",
    fill: "#D3A218"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M614.097733 532.203076a19.83488 28.842667 19.554 1 0 19.307-54.358417 19.83488 28.842667 19.554 1 0-19.307 54.358417Z",
    fill: "#D3A218"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M732.468629 599.272529a19.828053 28.84608 58.937 1 0 49.419131-29.768016 19.828053 28.84608 58.937 1 0-49.419131 29.768016Z",
    fill: "#D3A218"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M826.988837 600.072598a19.831467 28.84608 17.296 1 0-17.152353 55.08341 19.831467 28.84608 17.296 1 0 17.152353-55.08341Z",
    fill: "#D3A218"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M480.873513 621.715961a19.83488 28.84608 17.296 1 0-17.152354 55.08341 19.83488 28.84608 17.296 1 0 17.152354-55.08341Z",
    fill: "#D3A218"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M520.49171 705.001737a28.842667 19.831467 70.726 1 0 19.041125 54.452119 28.842667 19.831467 70.726 1 0-19.041125-54.452119Z",
    fill: "#D3A218"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M769.329267 639.776399a19.831467 28.84608 17.296 1 0-17.152353 55.083411 19.831467 28.84608 17.296 1 0 17.152353-55.083411Z",
    fill: "#D3A218"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M745.545276 732.468444a28.842667 19.83488 81.228 1 0 8.79718 57.01059 28.842667 19.83488 81.228 1 0-8.79718-57.01059Z",
    fill: "#D3A218"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M529.216227 782.979102a28.842667 19.831467 81.222 1 0 8.803149 57.009668 28.842667 19.831467 81.222 1 0-8.803149-57.009668Z",
    fill: "#D3A218"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M549.385631 538.797884a19.831467 28.84608 17.296 1 0-17.152354 55.08341 19.831467 28.84608 17.296 1 0 17.152354-55.08341Z",
    fill: "#D3A218"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M587.917709 555.691439a28.84608 19.83488 29.634 1 0 50.146122 28.526335 28.84608 19.83488 29.634 1 0-50.146122-28.526335Z",
    fill: "#D3A218"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M680.825488 527.775375a28.84608 19.831467 74.235 1 0 15.674522 55.52202 28.84608 19.831467 74.235 1 0-15.674522-55.52202Z",
    fill: "#D3A218"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M566.613315 613.509947a19.828053 28.849493 8.274 1 0-8.303297 57.098409 19.828053 28.849493 8.274 1 0 8.303297-57.098409Z",
    fill: "#D3A218"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedPassionFruit);
export default __webpack_public_path__ + "static/media/redPassionFruit.30924916e7b10899f6c1f6be18d43ddb.svg";
export { ForwardRef as ReactComponent };